import React from "react";

import { useLocation } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import {FooterDropdown} from "./Dropdown";
import { RESEARCH_PROJECTS, PROYGRADO, PROYPOS, RESEARCH_PAPERS, BASE_NAME } from "../routes";

export default function Footer({aboutRef, coursesRef, researchLineRef, navigate}) {

  const pagePrefixH = 'Header'
  const pagePrefixF = 'Footer'
  const location = useLocation();
  const pathname = location.pathname;
  const { t } = useTranslation('global');

  const scrollToSection = (alignment, sectionRef) => {
    if (sectionRef && sectionRef.current) {
      sectionRef.current.scrollIntoView(alignment);
    }
  };

  const goHome = (sectionRef) => {
    navigate('/')
    setTimeout(() => {
        scrollToSection({ behavior: 'smooth', block: 'start', inline: 'center'}, sectionRef)
    }, 350)
}
  const handleButtonClick = (e, sectionRef) => {
    e.preventDefault();

    if (pathname !== BASE_NAME) {
      goHome(sectionRef)
    } else {
      scrollToSection({ behavior: 'smooth', block: 'start', inline: 'center'}, sectionRef);
    }
  };  

  return (
    <>
      <footer className="relative bg-blueGray-200 pt-8 pb-6">
        <div
          className="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20 h-20"
          style={{ transform: "translateZ(0)" }}
        >
          <svg
            className="absolute bottom-0 overflow-hidden"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
            version="1.1"
            viewBox="0 0 2560 100"
            x="0"
            y="0"
          >
            <polygon
              className="text-blueGray-200 fill-current"
              points="2560 0 2560 100 0 100"
            ></polygon>
          </svg>
        </div>
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap text-center lg:text-left">
            {/* <div className="w-full lg:w-6/12 px-4">
              <h4 className="text-3xl font-semibold">Let's keep in touch!</h4>
              <h5 className="text-lg mt-0 mb-2 text-blueGray-600">
                Find us on any of these platforms.
              </h5>
              <div className="mt-6 lg:mb-0 mb-6">
                <button
                  className="bg-white text-lightBlue-400 shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
                  type="button"
                >
                  <i className="fab fa-twitter"></i>
                </button>
                <button
                  className="bg-white text-blueGray-800 shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
                  type="button"
                >
                  <i className="fab fa-github"></i>
                </button>
              </div>
            </div> */}
            <div className="w-full px-4">
              <div className="flex justify-between flex-wrap items-top mb-6">
                <div className="w-full lg:w-4/12 px-4">
                  <span className="block uppercase text-blueGray-500 text-sm font-semibold mb-2">
                    {t(`${pagePrefixF}.links`)}
                  </span>
                  <ul className="list-unstyled">
                    <li>
                      <button
                        className="text-blueGray-600 hover:text-blueGray-800 font-semibold text-center inline-flex items-center pb-2 text-sm"
                        onClick={(event) => handleButtonClick(event, aboutRef)}
                      >
                        {t(`${pagePrefixH}.about`)} 
                      </button>
                    </li>
                    <li>
                      <FooterDropdown 
                        buttonName={t(`${pagePrefixH}.research`)} 
                        dropdownId={'research'}
                        linkOptions={[
                          {
                            name: t(`${pagePrefixH}.research_papers`),
                            link: RESEARCH_PAPERS
                          },
                          {
                            name: t(`${pagePrefixH}.research_projects`), 
                            link: RESEARCH_PROJECTS
                          }
                      ]}
                        buttonOptions={[{
                          name: t(`${pagePrefixH}.research_lines`),
                          ref: researchLineRef
                        }]}
                        goHome={goHome}
                      />
                    </li>
                    <li>
                    <FooterDropdown 
                        buttonName={t(`${pagePrefixH}.teaching`)} 
                        dropdownId={'teaching'}
                        linkOptions={[{
                          name: t(`${pagePrefixH}.proygrado`), 
                          link: PROYGRADO
                        },
                        {
                          name: t(`${pagePrefixH}.proypos`),
                          link: PROYPOS
                        }]}
                        buttonOptions={[{
                          name: t(`${pagePrefixH}.courses`),
                          ref: coursesRef
                        }]}
                        goHome={goHome}
                      />
                    </li>
                  </ul>
                </div>
                <div className="w-full lg:w-4/12 px-4 md:mt-2">
                  <span className="block uppercase text-blueGray-500 text-sm font-semibold mb-2">
                    {t(`${pagePrefixF}.contact`)}
                  </span>
                  <ul className="list-unstyled">
                    <li className="text-blueGray-600 hover:text-blueGray-800 pb-2 text-sm">
                      Julio Herrera y Reissig 565, Montevideo, CA 11300
                    </li>
                    <li className="text-blueGray-600 hover:text-blueGray-800 pb-2 text-sm">
                      Facultad de Ingeniería, UDELAR
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <hr className="my-6 border-blueGray-300" />
          <div className="flex flex-wrap items-center md:justify-between justify-center">
            <div className="w-full md:w-4/12 px-4 mx-auto text-center">
              <div className="text-sm text-blueGray-500 font-semibold py-1">
                Copyright © {new Date().getFullYear()} Notus NextJS by{" "}
                <a
                  href="https://www.creative-tim.com?ref=nnjs-footer"
                  className="text-blueGray-500 hover:text-blueGray-800"
                >
                  Creative Tim
                </a>
                .
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
